export const formatAmount = (
  amount: number | string,
  currency: string,
  locale?: string
) => {
  const numericAmount =
    typeof amount === "string" ? Number.parseFloat(amount) : amount;
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currency.toUpperCase(),
  }).format(numericAmount);
};
